import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Config } from 'src/app/shared/models/config';
import { CommonService } from 'src/app/shared/services/common.service';
import { FinanceService } from 'src/app/shared/services/finance.service';
import { LedgerComponent } from '../ledger/ledger.component';

@Component({
  selector: 'app-ledger-list',
  templateUrl: './ledger-list.component.html',
  styleUrls: ['./ledger-list.component.scss'],
})
export class LedgerListComponent implements OnInit {
  public ledgerDataMap: Map<string, any[]> = new Map();
  public selectedLedger: any;
  public totalCredit: number = 0;
  public totalDebit: number = 0;
  constructor(
    private financeService: FinanceService,
    private commonService: CommonService,
    private modalService: NgbModal
  ) {}

  ngOnInit(): void {
    const ctxEmpId: number = this.commonService.getSessionItem(
      Config.context
    )?.companyId;
    this.financeService.getAllLedgers(ctxEmpId).subscribe((ledgerDataMap) => {
      this.ledgerDataMap = ledgerDataMap;
    });
  }

  public onRowClick(ledger: any): void {
    this.selectedLedger = ledger;
    this.openLedgerModal();
  }

  private openLedgerModal(): void {
    const modalRef = this.modalService.open(LedgerComponent, {
      size: 'xl',
      backdrop: 'static',
    });

    modalRef.componentInstance.ledger = this.selectedLedger;

    modalRef.result
      .then((result) => {
        // Handle modal close event if needed
      })
      .catch((error) => {
        // Handle modal close event if needed
      });
  }

  // Add these methods to your component class
  public calculateTotalDebit(ledgerArray: any[]): number {
    return ledgerArray.reduce(
      (total, ledger) => total + (parseFloat(ledger.debitAmount) || 0),
      0
    );
  }

  public calculateTotalCredit(ledgerArray: any[]): number {
    return ledgerArray.reduce(
      (total, ledger) => total + (parseFloat(ledger.creditAmount) || 0),
      0
    );
  }

  // private calculateTotal(): void {
  //   this.total = 0;

  //   // Check if ledgerDataMap is of type 'object'
  //   if (typeof this.ledgerDataMap === 'object') {
  //     // Iterate over each key in the object
  //     for (const key in this.ledgerDataMap) {
  //       // Check if the value corresponding to the key is an array
  //       if (Array.isArray(this.ledgerDataMap[key])) {
  //         // If it's an array, retrieve the array of entries
  //         const entries = this.ledgerDataMap[key];

  //         // Iterate over each entry in the array
  //         for (const entry of entries) {
  //           // Access creditAmount and debitAmount from the entry
  //           const creditAmount = entry.creditAmount || 0;
  //           const debitAmount = entry.debitAmount || 0;

  //           // Parse creditAmount and debitAmount as numbers before adding
  //           const parsedCreditAmount = parseFloat(creditAmount);
  //           const parsedDebitAmount = parseFloat(debitAmount);

  //           // Add the parsed values to the total
  //           this.total += parsedCreditAmount + parsedDebitAmount;
  //         }
  //       } else {
  //         // Log an error if the value is not an array
  //         console.error(`Unexpected type for ledgerDataMap[${key}]:`, typeof this.ledgerDataMap[key]);
  //       }
  //     }
  //   } else {
  //     // Log an error if ledgerDataMap is not of type 'object'
  //     console.error('Unexpected type for ledgerDataMap:', typeof this.ledgerDataMap);
  //   }
  // }
}
